import { render, staticRenderFns } from "./InfoPromo.vue?vue&type=template&id=42350716&scoped=true"
import script from "./InfoPromo.vue?vue&type=script&lang=js"
export * from "./InfoPromo.vue?vue&type=script&lang=js"
import style0 from "./InfoPromo.vue?vue&type=style&index=0&id=42350716&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42350716",
  null
  
)

export default component.exports